import {History, createBrowserHistory} from 'history';

const history: History = createBrowserHistory();

export default history;
